export var EnvironmentsEnum;
(function (EnvironmentsEnum) {
    EnvironmentsEnum["DEMO"] = "DEMO";
    EnvironmentsEnum["DEV"] = "DEV";
    EnvironmentsEnum["LOCALHOST"] = "localhost";
    EnvironmentsEnum["PROD"] = "PROD";
    EnvironmentsEnum["QA"] = "QA";
    EnvironmentsEnum["STG"] = "STG";
})(EnvironmentsEnum || (EnvironmentsEnum = {}));
//# sourceMappingURL=environments.enum.js.map